export const getAllParagraphs = async (context)=>{
    const paragraphs = context.document.body.paragraphs;
    paragraphs.load("items/style, items/text");
    await context.sync();
    return paragraphs;
};
export const getNextParagraph = (paragraphs, sectionTitle)=>{
    let didFindTarget = false;
    for(let i = 0; i < paragraphs.items.length; i++){
        const para = paragraphs.items[i];
        if (!didFindTarget && para.text.trim() === sectionTitle.trim()) {
            didFindTarget = true;
            continue;
        }
        if (didFindTarget && para.style && (para.style.startsWith("Heading") || para.style.startsWith("Title")) && para.text.trim().length > 0) {
            return para;
        }
    }
    return null;
};
